import Vue from 'vue';
// import utilities from '../../api/utilities.js';

import product from '../../api/product.js';
import cart from '../../api/cart.js';

import * as types from '../mutation-types';

import _ from 'lodash';

const state = {
  active_product: {},
  active_product_modifiers: [],
  active_product_quantity: 1,
  active_product_list_price: 0,
  list_products: [],
  list_categories: [],
};

// getters
const getters = {
  // checkoutStatus: state => state.checkoutStatus,
  product: state => state.active_product,

  products: state => state.list_products,

  active_product_list_price: (state) => {
    return state.active_product_list_price;
  },

  active_product_price: (state) => {
    // TODO: Add least add a description on what it is. I have to read it 1 minute to understand :'(
    let price = state.active_product.price_list ? state.active_product_list_price : state.active_product.price;
    let tempTotal = 0;
    tempTotal += price * state.active_product_quantity;

    if (state.active_product_modifiers.length > 0) {
      state.active_product_modifiers.forEach((modifier) => {
        switch (modifier.type) {
          case 'FIXED_INCREASE':
            tempTotal += modifier.amount * state.active_product_quantity;
            break;

          case 'FIXED_DECREASE':
            tempTotal -= modifier.amount * state.active_product_quantity;
            break;

          default:
        }

        if (tempTotal < 0) {
          tempTotal = 0;
        }
        return tempTotal;
      });
    }

    return tempTotal.toFixed(2);
  },

  active_product_quantity: state => state.active_product_quantity,

  categories: state => state.list_categories,

  getCategoriesWithEmpty: state => {
    let list = state.list_categories;
    if (list.length > 0) {
      list.unshift({
        category_id: '',
        name: '',
      });
    }

    return list;
  },
};

// actions
const actions = {
  list_products ({ commit, state, rootState }, parameters) {
    let selected_module_id = parameters.module_id;
    let selected_category_id = parameters.category_id;
    if (!selected_category_id) {
      selected_category_id = rootState.Module.selected_category;
    }

    // console.log('SM and SC,', selected_module_id, selected_category_id);

    product.listProducts(
      selected_module_id,
      selected_category_id,
      rootState.Module.selected_sort_order,
      (response) => {
        // TODO: This call should also return 'OK' or something similar.
        // if (utilities.isValidResponse(response) === true) {
        // } else {
        //   console.log('problem :(', response);
        // }
        commit(types.PRODUCT_LIST, {
          data: response.data.data
        });
      },
      () => {
        commit(types.PRODUCT_LIST_FAILURE);
      }
    );
  },
  info_product ({ commit, state }, parameters) {
    commit(types.PRODUCT_INFO, { data: {} });
    return product.infoProduct(
      parameters.module_id,
      parameters.product_id,
      (response) => {
        commit(types.PRODUCT_INFO, {
          data: response.data.data
        });
      },
      () => {
        // commit(types.PRODUCT_INFO_FAILURE);
      }
    );
  },
  add_active_product_to_cart ({commit, state, rootState}) {
    // API CALL
    let data = {
      visitor_id: rootState.Module.visitor_id,
      module_id: rootState.Module.active_module.module_id,
      product_id: state.active_product.product_id,
      quantity: state.active_product_quantity,
      modifiers: state.active_product_modifiers,
      // i will refactory this soon
      price_details: state.active_product_price_details || {
        price_list: false,
        price: state.active_product.price,
        price_partial: state.active_product.price_partial || 0
      }
    };

    cart.addProductToCart(
      data,
      (response) => {
        commit(types.CART_REPLACE, response.data);
      },
      (response) => {
      });
      // commit(types.PRODUCT_ADD_ACTIVE_PRODUCT_TO_CART, {});
  },

  set_active_product_price_details ({commit, state}, payload) {
    commit(types.PRODUCT_SET_ACTIVE_PRODUCT_PRICE_DETAILS, payload);
  },

  set_active_product_quantity ({commit, state}, parameters) {
    commit(types.PRODUCT_SET_ACTIVE_PRODUCT_QUANTITY, {
      quantity: parameters.quantity
    });
  },

  set_active_product_price ({commit, state}, price) {
    commit(types.PRODUCT_SET_ACTIVE_PRODUCT_PRICE, price);
  },

  add_to_active_modifiers ({ commit, state }, parameters) {
    let tempModifier = _.clone(state.active_product.modifiers[parameters.modifier_index]);
    commit(types.PRODUCT_MODIFIER_ADD, {
      modifier: tempModifier
    });
  },
  remove_from_active_modifiers ({ commit, state }, parameters) {
    commit(types.PRODUCT_MODIFIER_REMOVE, {
      modifier: state.active_product.modifiers[parameters.modifier_index]
    });
  },

  init_categories ({ commit, state, rootState }, parameters) {
    product.listCategories(parameters.module_id,
      (categories) => {
        commit(types.CATEGORY_REPLACE_CATEGORIES, categories);

        if (parameters.category_id) {
          // Set category from URI
          commit(types.CATEGORY_SET_SELECTED_CATEGORY, { category_id: parameters.category_id });
        }
      }, (response) => {
      }
    );
  },
};

// mutations
const mutations = {
  [types.PRODUCT_LIST] (state, { data }) {
    Vue.set(state, 'list_products', data);
  },
  [types.PRODUCT_INFO] (state, { data }) {
    Vue.set(state, 'active_product', data);

    // Reset related states.
    Vue.set(state, 'active_product_modifiers', []);
    Vue.set(state, 'active_product_quantity', 1);
  },
  [types.PRODUCT_MODIFIER_ADD] (state, data) {
    let tempModifiers = _.cloneDeep(state.active_product_modifiers);
    tempModifiers.push(data.modifier);
    Vue.set(state, 'active_product_modifiers', tempModifiers);
  },
  [types.PRODUCT_MODIFIER_REMOVE] (state, data) {
    let tempModifiers = _.cloneDeep(state.active_product_modifiers);
    tempModifiers = _.remove(tempModifiers, (tempModifier) => {
      // Return everything that doesn't match the comparison.
      // Delete only the modifier we want to be deleted.
      return tempModifier.product_modifier_id !== data.modifier.product_modifier_id;
    });
    Vue.set(state, 'active_product_modifiers', tempModifiers);
  },

  [types.PRODUCT_SET_ACTIVE_PRODUCT_PRICE_DETAILS] (state, data) {
    Vue.set(state, 'active_product_price_details', data);
  },

  [types.PRODUCT_SET_ACTIVE_PRODUCT_QUANTITY] (state, data) {
    Vue.set(state, 'active_product_quantity', data.quantity);
  },

  [types.PRODUCT_SET_ACTIVE_PRODUCT_PRICE] (state, price) {
    state.active_product_list_price = price;
  },

  [types.CATEGORY_REPLACE_CATEGORIES] (state, data) {
    Vue.set(state, 'list_categories', data);
  },

};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/Product.js